import { all } from "redux-saga/effects";
import { watcherInit } from "./init";
import { watcherAuth } from "./auth";
import { watcherUser } from "./user";

import { watcherProject } from "./project";
import { watcherProjectTeam } from "./team";
import { watcherProvince } from "./province";

import { pettyCashierWatcherAccountReview } from "./accountReview/pettyCashierAccountReview";
import { managerWatcherAccountReview } from "./accountReview/managerAccountReview";
import { pettyCashierWatcherPayment } from "./payment/pettyCashierPayment";
import { managerWatcherPayment } from "./payment/managerPayment";
import { pettyCashierWatcherReceive } from "./receive/pettyCashierReceive";
import { managerWatcherReceive } from "./receive/managerReceive";
import { pettyCashierWatcherMonthlyBudget } from "./monthlyBudget/pettyCashierMonthlyBudget";
import { pettyCashierWatcherMonthlyBudgetReview } from "./monthlyBudget/review/pettyCashierMonthlyBudgetReview";
import { watcherEvent } from "./event";
import { watcherPettyCashierDashboard } from "./dashboard/pettyCashierDashboard";
import { watcherManagerDashboard } from "./dashboard/managerDashboard";
import { pettyCashierWatcherOverallCost } from "./overallCost/pettyCashierOverallCost";
import { managerWatcherOverallCost } from "./overallCost/managerOverallCost";
import { pettyCashierWatcherOverallCostDetail } from "./overallCost/detail/pettyCashierOverallCostDetail";
import { managerWatcherOverallCostDetail } from "./overallCost/detail/managerOverallCostDetail";
import { watcherNotifications } from "./notification";
import { watcherInvitation } from "./invitation";
import { pettyCashierWatcherPettyCash } from "./pettyCash/pettyCashierPettyCash";
import { managerWatcherPettyCash } from "./pettyCash/managerPettyCash";
import { watcherProjectSetting } from "./projectSetting";
import { watcherFile } from "./file";
import { watcherDownloadFile } from "./downloadFile";
import { watcherTicket } from "./ticket";
import { watcherAnnouncement } from "./announcement";
import { watcherPremium } from "./premium";
import { watcherWarnOwner } from "./warnOwner";
import { watcherTransaction } from "./transaction";
import { watcherCountryCode } from "./countryCode";
import { watcherCurrencies } from "./currencies";

import { watcherAccountTitle } from "./accountTitle";
import { watcherCostCenter } from "./costCenter";
import { watcherHashtag } from "./hashtag";
import { watcherContact } from "./contact";

import { pettyCashierWatcherMonthlyReview } from "./monthlyReview/pettyCashierMonthlyReview";
import { pettyCashierWatcherHashtagReport } from "./hashtagReport/pettyCashierHashtagReport";
import { managerWatcherHashtagReport } from "./hashtagReport/managerHashtagReport";
import { pettyCashierWatcherHashtagDetailReport } from "./hashtagReport/detail/pettyCashierHashtagDetailReport";
import { managerWatcherHashtagDetailReport } from "./hashtagReport/detail/managerHashtagDetailReport";

import { watcherSubItem } from "./subItems";

import { pettyCashierWatcherContactReport } from "./contactReport/pettyCashierContactReport";
import { managerWatcherContactReport } from "./contactReport/managerContactReport";
import { pettyCashierWatcherContactDetailReport } from "./contactReport/detail/pettyCashierContactDetailReport";
import { managerWatcherContactDetailReport } from "./contactReport/detail/managerContactDetailReport";
import { pettyCashierWatcherPettyCashBudget } from "./pettyCashBudget/pettyCashierPettyCashBudget";
import { managerWatcherPettyCashBudget } from "./pettyCashBudget/managerPettyCashBudget";

import { pettyCashierWatcherVatReview } from "./vatReview/pettyCashierVatReview";
import { managerWatcherVatReview } from "./vatReview/managerVatReview";

import { watcherUserManagement } from "./userManagement";
import { watcherPettyCashierBudgetComparativeReport } from "./pettyCashBudget/pettyCashierBudgetComparativeReport";

export default function* rootSaga() {
  yield all([
    watcherInit(),
    watcherAuth(),
    watcherUser(),

    watcherProject(),
    watcherProjectTeam(),
    watcherProvince(),

    pettyCashierWatcherAccountReview(),
    managerWatcherAccountReview(),
    pettyCashierWatcherPayment(),
    managerWatcherPayment(),
    pettyCashierWatcherReceive(),
    managerWatcherReceive(),
    watcherEvent(),
    watcherPettyCashierDashboard(),
    watcherManagerDashboard(),
    pettyCashierWatcherOverallCost(),
    managerWatcherOverallCost(),
    pettyCashierWatcherOverallCostDetail(),
    managerWatcherOverallCostDetail(),
    watcherNotifications(),
    watcherInvitation(),
    pettyCashierWatcherPettyCash(),
    managerWatcherPettyCash(),
    watcherProjectSetting(),
    watcherFile(),
    watcherDownloadFile(),
    watcherTicket(),
    watcherAnnouncement(),
    watcherPremium(),
    watcherWarnOwner(),
    watcherTransaction(),
    watcherCountryCode(),
    watcherCurrencies(),

    watcherAccountTitle(),
    watcherCostCenter(),
    watcherHashtag(),
    watcherContact(),

    pettyCashierWatcherMonthlyReview(),
    pettyCashierWatcherHashtagReport(),
    managerWatcherHashtagReport(),
    pettyCashierWatcherHashtagDetailReport(),
    managerWatcherHashtagDetailReport(),

    watcherSubItem(),

    pettyCashierWatcherPettyCashBudget(),

    pettyCashierWatcherVatReview(),
    managerWatcherVatReview(),
    pettyCashierWatcherContactReport(),
    managerWatcherContactReport(),
    pettyCashierWatcherContactDetailReport(),
    managerWatcherContactDetailReport(),
    pettyCashierWatcherPettyCashBudget(),
    pettyCashierWatcherMonthlyBudget(),
    pettyCashierWatcherMonthlyBudgetReview(),

    watcherUserManagement(),

    managerWatcherPettyCashBudget(),
    watcherPettyCashierBudgetComparativeReport()
  ]);
}
